import { type IconBulletItem, IconBulletList } from "./IconBulletList";
import { PreTestCard } from "./PreTestCard";

type Props = {
	title?: string;
	items: IconBulletItem[];
};

const TestChecklist = ({ title = "Test Checklist", items }: Props) => (
	<PreTestCard title={title}>
		<IconBulletList items={items} />
	</PreTestCard>
);

export default TestChecklist;
